<template>
  <div>
    <NavBar></NavBar>
    <SideMenu></SideMenu>
    <div>
      <component :is="currentComponent"></component>
     </div>
    <v-main
      :style="{
        'margin-left': '240px',
        'background-color': '#f1f2f8',
        'min-height': '100vh',
      }"
    >
      <router-view></router-view>
    </v-main>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import NavBar from '@/components/NavBar.vue';
import SideMenu from '@/components/SideMenu.vue';
import CustomerServiceSideMenu from '@/components/SideMenus/Customer_Service_SideMenu.vue';

export default {
  name: 'DefaultLayout',
  components: {
    NavBar,
    SideMenu,
    CustomerServiceSideMenu,
  },
  data: () => ({
    //
  }),
  computed: {
    ...mapGetters([
      'department',
    ]),
    currentComponent() {
      const customerServiceDepartments = ['Customer_Service'];
      if (customerServiceDepartments.includes(this.department)) {
        return 'CustomerServiceSideMenu';
      }
      return 'SideMenu';
    },
  },
};
</script>

<style lang="scss">
// @import '@/assets/scss/main.scss';
</style>
